export const Formats = {
  CSV: 'csv',
  XLS: 'xls',
  XLSX: 'xlsx',
  TXT: 'txt',
  PDF: 'pdf',
};

export const MediaType = {
  [Formats.CSV]: '.csv, text/csv',
  [Formats.XLS]: 'application/vnd.ms-excel',
  [Formats.XLSX]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  [Formats.TXT]: 'text/plain',
  [Formats.PDF]: 'application/pdf',
};

export const getMediaTypes = formats => formats.map(f => MediaType[f]).join(', ');

// MediaType entries can hold multiple comma-separated values (e.g. an extension + a MIME type,
// for the <input accept> attribute). Pick the actual MIME type out of one entry.
const extractMimeType = mediaType =>
  (mediaType || '')
    .split(',')
    .map(part => part.trim())
    .find(part => part.includes('/'));

export const getMediaTypeForExtension = extension => extractMimeType(MediaType[extension]);

// The API routes uploads by request entity media type and has no filename-extension fallback,
// so an empty File.type (some browsers leave it blank for less common extensions, e.g. .pdf
// dragged from certain sources) must not produce a typeless request. Fall back to the
// extension -> media type mapping above, reusing the same MediaType map used for the file
// picker's accept attribute.
export const getFileContentType = file => {
  if (file && file.type) {
    return file.type;
  }

  const extension = ((file && file.name) || '').split('.').pop().toLowerCase();
  return getMediaTypeForExtension(extension);
};
